<!-- 通用订单页 -->
<template>
  <div class="order">
    <goods-info class="goodsinfo"/>
    <app-payment class="payment" @paymentSelected="onPaymentSelected" />
    <div class="pay-btn" @click="doPay">立即支付<span class="pay-price">{{account}}</span></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { genOrder, payOrder, getOrder } from '@/api/order'
import GoodsInfo from '@/views/order/goodsInfo'
import AppPayment from '@/views/order/payment'
import config from '@/config/config'

export default {
  components: { GoodsInfo, AppPayment },
  data () {
    return {
      payment: '',
    }
  },
  computed: {
    ...mapGetters([
      'goodsId',
      'content',
      'desc',
      'name',
      'price',
      'priceLabel',
      'shareId',
      'account',
      'discountDetail',
      'discountList',
    ]),
    totalPrice: {
      get: function () {
        let priceLabel = this.price && this.price / 100 + '' || ''
        return (priceLabel.indexOf('.') >= 0) ? (+priceLabel).toFixed(2) : priceLabel + '.00'
      }
    },
  },
  created() {
    // 处理支付回调
    if (this.$route.query.payResult) {
      this.onPayBack()
    } else if (!this.goodsId && !this.$route.query.goods_id) {
      // 非支付回调，且没有商品信息，则跳回商品页
      this.goBuyvip()
    }
  },
  mounted() {

  },
  methods: {
    onPaymentSelected(payment) {
      this.payment = payment
    },
    async doPay() {
      this.$daidiLoading.show({
        text: '支付中，请稍候...',
      })
      setTimeout(() => {
        this.$daidiLoading.hide()
        this.$toast.show({
          text: '网络不畅通，请稍候再试'
        })
      }, 10000)
      try {
        let orderInfo = await genOrder(this.$store.getters.token, this.goodsId, this.price, this.shareId)
        let payInfo = await payOrder(orderInfo.order.order_id, this.payment)
        if (payInfo) window.location.href = payInfo.payUrl
      } catch (e) {
        this.$toast.show({
          text: '支付失败，请稍候再试'
        })
        console.error(e)
      }
    },
    // 根据orderId获取订单信息
    async getOrderStatus(orderId) {
      try {
        let orderInfo = await getOrder(orderId)
        return orderInfo.order.status
      } catch (e) {
        console.log(e)
      }
    },
    // 处理支付回调
    onPayBack() {
      let payResult = this.$route.query.payResult // 支付结果，不是订单结果
      let orderId = this.$route.query.tradeNo // 订单号
      this.$daidiLoading.show({
        text: '查询结果中，请稍候...',
      })
      return this.goPayResult()
    },
    // 跳转到vip购买页
    goBuyvip() {
      // this.$router.replace('buyvip')
      // Tips: 用location跳转，避免跳转后不能分享的问题
      location.href = `${config.siteRoot}/buyvip`
    },
    goPayResult() {
      let tradeNo = this.$route.query.tradeNo
      let orderId = tradeNo.replace(tradeNo.match(/^[0-9]+(\D*.*)/)[1], '')
      this.$router.replace({
        path: 'payresult',
        query: {
          order_payback_url: this.$route.query.order_payback_url,
          payResult: this.$route.query.payResult,
          order_id: orderId,
        },
      })
    },
  },
}
</script>

<style scoped lang="less">
  .order {
    position: relative;
    padding-top: .32rem;
    padding-bottom: 1.4rem;
    box-sizing: border-box;
  }
  .goodsinfo {
    margin-bottom: .48rem;
  }
  .pay-btn {
    display: block;
    position: fixed;
    bottom: .2rem;
    left: 50%;
    transform: translateX(-50%);
    margin: 0 auto;
    width: 6.7rem;
    height: 1.12rem;
    line-height: 1.12rem;
    text-align: center;
    font-size: .34rem;
    color: #604038;
    font-weight: bold;
    border-radius: .12rem;
    background: linear-gradient(-90deg, #FEB800, #FEDC42);
    box-shadow: 0 2px 16px 0 rgba(254,184,0,0.32);
  }
</style>
